<div class="trace-matrix-wrapper">

  <!-- KPI Dashboard Section -->
  <div class="row g-3 mb-3">
    <div class="col-lg-4 col-md-6" (click)="applyCoverageFilter('all')">
      <div class="card kpi-card kpi-card-clickable text-center h-100 shadow-sm" [class.active]="coverageFilterState === 'all'">
        <div class="card-body d-flex flex-column justify-content-center">
          <h5 class="card-title text-primary small text-uppercase fw-bold">Total Requirements</h5>
          <p class="card-text kpi-value display-5 fw-bolder mb-0">{{ kpiTotalRequirements }}</p>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6" (click)="applyCoverageFilter('covered')">
      <div class="card kpi-card kpi-card-clickable text-center h-100 shadow-sm" [class.active]="coverageFilterState === 'covered'">
        <div class="card-body d-flex flex-column justify-content-center">
          <h5 class="card-title text-success small text-uppercase fw-bold">Covered</h5>
          <p class="card-text kpi-value display-5 fw-bolder mb-0">{{ kpiCovered }}</p>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12" (click)="applyCoverageFilter('not-covered')">
      <div class="card kpi-card kpi-card-clickable text-center h-100 shadow-sm" [class.active]="coverageFilterState === 'not-covered'">
        <div class="card-body d-flex flex-column justify-content-center">
          <h5 class="card-title text-danger small text-uppercase fw-bold">Not Covered</h5>
          <p class="card-text kpi-value display-5 fw-bolder mb-0">{{ kpiNotCovered }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Toggleable RTM Card -->
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center"
         (click)="isRtmVisible = !isRtmVisible"
         style="cursor: pointer;"
         role="button"
         [attr.aria-expanded]="isRtmVisible"
         aria-controls="rtm-content-body">
      <h3 class="h5 mb-0">Requirements Details</h3>
      <button class="btn btn-sm btn-outline-secondary" type="button" tabindex="-1">
        <i class="fa" [ngClass]="isRtmVisible ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </button>
    </div>

    <!-- This is the body that will be toggled -->
    <div class="card-body p-3" *ngIf="isRtmVisible" id="rtm-content-body">

      <div *ngIf="requirements && requirements.length > 0; else noRequirements">

        <!-- Filter Buttons & Add Button -->
        <div class="mb-3 d-flex justify-content-between align-items-center">
          <div class="btn-group" role="group" aria-label="Filter by category">
            <button type="button" class="btn btn-sm"
                    [ngClass]="currentFilter === null ? 'btn-primary' : 'btn-outline-primary'"
                    (click)="applyFilter(null)">
              All <span class="badge bg-light text-dark ms-1">{{ getTotalRequirementsCount() }}</span>
            </button>
            <button type="button" class="btn btn-sm"
                    *ngFor="let cat of categoriesWithCounts"
                    [ngClass]="currentFilter === cat.name ? 'btn-primary' : 'btn-outline-primary'"
                    (click)="applyFilter(cat.name)">
              {{ cat.name }} <span class="badge bg-light text-dark ms-1">{{ cat.count }}</span>
            </button>
          </div>

          <button class="btn btn-sm btn-success" (click)="onAddNew()" [disabled]="isAddingNew">
            <i class="fa fa-plus me-1"></i> Add Requirement
          </button>
        </div>

        <!-- RTM Table -->
        <div class="table-responsive">
          <table class="table table-sm table-hover table-bordered">
            <thead class="table-light">
            <tr>
              <th scope="col" style="width: 10%;">Req ID</th>
              <th *ngIf="currentFilter === null" scope="col" style="width: 15%;">Category</th>
              <th scope="col">Description</th>
              <th *ngIf="microScenariosGenerated" scope="col" style="width: 10%;">Covered</th>
              <th *ngIf="microScenariosGenerated" scope="col" style="width: 20%;">Related Micro Scenarios</th>
              <th scope="col" style="width: 1%; white-space: nowrap;">Actions</th>
            </tr>
            </thead>
            <tbody>
            <!-- Row for adding a new requirement -->
            <tr *ngIf="isAddingNew" class="table-info">
              <td><span class="badge bg-primary">NEW</span></td>
              <td *ngIf="currentFilter === null">
                <input type="text" class="form-control form-control-sm" [(ngModel)]="editData.category" placeholder="Category">
              </td>
              <td>
                <input type="text" class="form-control form-control-sm" [(ngModel)]="editData.description" placeholder="Requirement description">
              </td>
              <td *ngIf="microScenariosGenerated" colspan="2"></td>
              <td class="actions-cell">
                <button class="btn btn-sm btn-action-save" (click)="onSaveNew()" title="Save New"><i class="fa fa-save"></i></button>
                <button class="btn btn-sm btn-action-cancel" (click)="onCancel()" title="Cancel"><i class="fa fa-times"></i></button>
              </td>
            </tr>

            <!-- The main loop with inline editing logic -->
            <ng-container *ngFor="let req of filteredRequirements; trackBy: trackByReqId">

              <!-- Row for displaying or editing a requirement -->
              <tr [class.table-info]="editingReqId === req.id" [class.req-row]="editingReqId !== req.id"
                  (click)="toggleRow(req)" style="cursor: pointer;">

                <!-- Display Mode -->
                <ng-container *ngIf="editingReqId !== req.id">
                  <td>{{ req.fullId }}</td>
                  <td *ngIf="currentFilter === null">
                    <span class="badge bg-secondary">{{ req.category }}</span>
                  </td>
                  <td>{{ req.description }}</td>
                  <td *ngIf="microScenariosGenerated">
                    <span class="badge" [ngClass]="req.covered ? 'bg-success' : 'bg-danger'">
                      <i class="fa me-1" [ngClass]="req.covered ? 'fa-check-circle' : 'fa-times-circle'"></i>
                      {{ req.covered ? 'Yes' : 'No' }}
                    </span>
                  </td>
                  <td *ngIf="microScenariosGenerated">
                    <span *ngIf="req.relatedMicroScenarioIds && req.relatedMicroScenarioIds.length > 0; else noRelatedScenarios" class="small">
                      {{ req.relatedMicroScenarioIds.join(', ') }}
                    </span>
                    <ng-template #noRelatedScenarios>
                      <span class="text-muted fst-italic small">None</span>
                    </ng-template>
                  </td>
                  <td class="actions-cell">
                    <button class="btn btn-sm btn-action-edit" (click)="onEdit(req); $event.stopPropagation()" title="Edit">
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button class="btn btn-sm btn-action-delete" (click)="onDelete(req.id); $event.stopPropagation()" title="Delete">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </ng-container>

                <!-- Edit Mode -->
                <ng-container *ngIf="editingReqId === req.id">
                  <td>{{ req.fullId }}</td>
                  <td *ngIf="currentFilter === null">
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="editData.category" (click)="$event.stopPropagation()">
                  </td>
                  <td>
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="editData.description" (click)="$event.stopPropagation()">
                  </td>
                  <td *ngIf="microScenariosGenerated" colspan="2">
                    <span class="text-muted fst-italic small">Editing...</span>
                  </td>
                  <td class="actions-cell">
                    <button class="btn btn-sm btn-action-save" (click)="onSave(); $event.stopPropagation()" title="Save">
                      <i class="fa fa-save"></i>
                    </button>
                    <button class="btn btn-sm btn-action-cancel" (click)="onCancel(); $event.stopPropagation()" title="Cancel">
                      <i class="fa fa-times"></i>
                    </button>
                  </td>
                </ng-container>
              </tr>

              <!-- Expandable Detail Row for Associated Tests -->
              <tr *ngIf="expandedRequirementId === req.fullId">
                <td [attr.colspan]="getColspan()" class="expanded-details-cell">

                  <!-- 1. Sezione per i Test Finali/Consolidati -->
                  <div *ngIf="consolidatedTestsForExpandedRow.length > 0" class="test-section mb-3">
                    <h6 class="text-success"><i class="fa fa-check-double me-2"></i>Final Consolidated Tests ({{ consolidatedTestsForExpandedRow.length }})</h6>
                    <app-test-table
                      [tests]="consolidatedTestsForExpandedRow"
                      [isSimplifiedDisplayMode]="true"
                      [showActions]="false">
                    </app-test-table>
                  </div>

                  <!-- 2. Sezione per i Test Grezzi Originali -->
                  <div *ngIf="rawTestsForExpandedRow.length > 0" class="test-section">
                    <h6 class="text-primary"><i class="fa fa-flask me-2"></i>Original Raw Tests ({{ rawTestsForExpandedRow.length }})</h6>
                    <app-test-table
                      [tests]="rawTestsForExpandedRow"
                      [isSimplifiedDisplayMode]="true"
                      [showActions]="false">
                    </app-test-table>
                  </div>

                  <!-- Messaggio se non vengono trovati test -->
                  <ng-container *ngIf="rawTestsForExpandedRow.length === 0 && consolidatedTestsForExpandedRow.length === 0">
                    <div class="text-muted small my-2" *ngIf="microScenariosGenerated">
                      <i class="fa fa-info-circle me-1"></i>No associated tests found for this requirement.
                    </div>
                  </ng-container>

                </td>
              </tr>
            </ng-container>
            </tbody>
          </table>
        </div>
      </div>

    </div> <!-- End of Card Body -->
  </div> <!-- End of Card -->

  <!-- Template for when there are no requirements at all -->
  <ng-template #noRequirements>
    <div class="alert alert-info mt-3">
      <i class="fa fa-info-circle me-2"></i>
      No analysis data provided or requirements parsed yet. Please generate or load an analysis in the Scenario Generator.
    </div>
  </ng-template>
</div>
